
import { useState, useEffect, ChangeEvent } from "react";
import Sidebar from "../../components/sidebar";
import { getStoredUserData, getUserSession, isAdmin, isAuthenticated, isDriver } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { ApiClient } from "../../utils/apiclient";
import SearchBox from "../../components/search_box";
import TripsTable from "./trips_table";
import { ISelectOption, ISession, Trip, User, Vehicle } from "../../utils/types";
import TopStrip from "../../components/top_strip";
import PageControl from "../../components/page_control";
import Spinner from "../../components/spinner";
import { get } from "http";

const Trips = (_props: any) => {
  const navigate = useNavigate();
  const notifications = []
  const session: ISession | null = getUserSession();
  const userData = getStoredUserData();
  const apiClient = new ApiClient(session?.accessToken);
  const [trips, setTrips] = useState([])
  const [filteredTrips, setFilteredTrips] = useState(trips)
  const [pageInfo, setPageInfo] = useState<any>({ totalPages: 0, totalCount: 0, currentPage: 1, pageSize: 15, hasNext: false, hasPrevious: false });
  const [pageSize, setPageSize] = useState<number>(20)
  const [page, setPage] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(false)
  const [driverOptions, setDriverOptions] = useState<ISelectOption[]>([])
  const [vehicleOptions, setVehicleOptions] = useState<ISelectOption[]>([])
  const [filterOption, setFilterOption] = useState<string | undefined | number>('driver')
  const [searchOption, setSearchOption] = useState<ISelectOption | null>(null)


  const getTrips = async (pageSize: number, page: number) => {
    setLoading(true)
    var response;
    if (isDriver(userData)) {
      response = await apiClient.getDriverTrips(userData?.id!,{take:pageSize, page:page});
      console.log("🚀 ~ getTrips ~ response driver:", response)
    }
    else {
      response = await apiClient.getTrips({take:pageSize, page:page});
      console.log("🚀 ~ getTrips ~ response:", response)
    }

    if (response && response.status == 200) {
      const data = response.data;
      setTrips(data.trips)
      setFilteredTrips(data.trips)
      setPageInfo({ totalPages: data.totalPages, totalCount: data.totalCount, currentPage: data.page, pageSize: data.pageSize, hasNext: data.hasNext, hasPrevious: data.hasPrevious })

    }
    setLoading(false)
  }

  const getPreviousPage = () => {
    setPage(page - 1)
  }
  const getNextPage = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    console.log("🚀 ~ getNextPage ~ nextPage:", page)
  }
  const handlePageSizeChange = (pageSize: number) => {
    if (pageSize && pageSize >= 10) {
      setPageSize(pageSize);
      setPage(1)
    }
    else {
      setPageSize(20);
      setPage(1);
    }
  }

  const handleFilter = (option: ISelectOption | null) => {
    if (option) {
      const id = option.value
      const t = trips.filter((trip: Trip) => {
        return filterOption === 'vehicle' ? trip.vehicle_id === Number(id) : trip.driver === Number(id)
      })
      setFilteredTrips(t);
    }
    else setFilteredTrips(trips)
  }
  const searchApi = async (query: string) => {
    setLoading(true)
    const response = await apiClient.searchTrips(query, { page: page, take: pageSize })
    const data = response.data;
    setPageInfo({ totalPages: response.data.totalPages, totalCount: response.data.totalCount, currentPage: response.data.page, pageSize: response.data.pageSize, hasNext: response.data.hasNext, hasPrevious: response.data.hasPrevious })
    setTrips(data.trips);
    setFilteredTrips(data.trips);
    setFilterOption('')

    setLoading(false)
  }
  const getActiveDrivers = async () => {
    if (isAdmin(userData)) {
      const drivers = await apiClient.getActiveDrivers();

      const options = drivers.map((driver: User) => {
        return {
          value: driver.id, label: `${driver.fname} ${driver.lname}`
        }
      })
      setDriverOptions(options)
    }

  }
  const getActiveVehicles = async () => {
    if(isAdmin(userData)){
    const req = await apiClient.getVehicles();

    const options = req.vehicles.map((vehicle: Vehicle) => {
      return {
        value: vehicle.id, label: vehicle.pnumber
      }
    })
    setVehicleOptions(options)
  }
  }
  const handleSearch = (option: ISelectOption) => {
    setSearchOption(option)
    const query = filterOption === 'vehicle' ? `?vehicle=${option?.label}` : `?driver=${option?.value}`
    searchApi(query)
  }
  const handleFilterChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.currentTarget.value;
    setFilterOption(value);
    if (value === 'driver') {

      setSearchOption(driverOptions[0]);
    }
    else if (value === 'vehicle') {
      setSearchOption(vehicleOptions[0]);
    }
    else {
      setSearchOption(null)
    }

  }
  useEffect(() => {
    if (isAuthenticated()) {
      getTrips(pageSize, page);
      getActiveDrivers();
      getActiveVehicles();
    }
    else navigate('/login', { state: { targetPath: '/trips' } })
  }, [pageSize, page])
  return (
    <>
      <div className='w-full flex justify-end items-center bg-gray-100 pe-4'>
        <TopStrip user={userData} />
      </div>
      <main className='w-full flex bg-white min-h-full'>
        <div className='md:w-2/12 flex flex-col items-start text-center justify-center'>
          <Sidebar
            notificationCount={notifications.length}
            user={userData}
            active={4}
          />{' '}
          f
        </div>

        <div className='md:w-9/12 mx-auto space-y-4 mt-2'>
          <div className='w-full text-textDefault mt-2'>
            <div className='w-full flex items-center justify-between pt-2'>
              <p className='text-2xl font-bold'>Trips</p>
              {isAdmin(userData) && (
                <div className='w-full flex justify-end items-center md:w-6/12'>
                  <div className='text-left'>
                    <label className=''>Filter by {filterOption}</label>
                    <select
                      className='form-control'
                      onChange={handleFilterChange}
                      defaultValue={filterOption}>
                      <option value='-'>select</option>
                      <option value='driver'>Driver</option>
                      <option value='vehicle'>Vehicle</option>
                    </select>
                  </div>
                  <SearchBox
                    className='w-full md:w-6/12 flex space-x-2 my-4 items-center justify-end pt-6'
                    onChange={handleFilter}
                    onSearch={handleSearch}
                    options={
                      filterOption === 'driver' || filterOption === ''
                        ? driverOptions
                        : vehicleOptions
                    }
                  />
                </div>
              )}
            </div>
            {loading ? (
              <Spinner className='spinner-md mt-6' />
            ) : (
              <>
                <div className='w-full border-top flex-row flex-start bg-main-color align-items-center '>
                  <PageControl
                    pageSize={pageSize}
                    onNext={getNextPage}
                    onPrevious={getPreviousPage}
                    currentPage={page}
                    totalPages={pageInfo.totalPages}
                    onPageSizeChange={(pageSize: number) => {
                      handlePageSizeChange(pageSize);
                    }}
                    hasNext={pageInfo.hasNext}
                    hasPrevious={pageInfo.hasPrevious}
                  />
                </div>
                <TripsTable data={filteredTrips} />
              </>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default Trips;
